import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import messages from "../../../../../assets/locale/messages";
import Button from "../../../../../components/Button";
import CompanyInfoSection from "../components/CompanyInfoSection";
import UploadDocuments from "./UploadDocuments";
import WaitingDocumentsUpload from "./WaitingDocumentsUpload";
import DocumentsSection from "./ReviewUploadedDocuments/DocumentsSecion";
import RepresentativeSection from "./ReviewUploadedDocuments/RepresentativeSection";
import TransactionDetails from "./ReviewUploadedDocuments/TransactionDetails";
import RequiredDocsEdit from "./RequiredDocsEdit";
import { ROUTE_PATHS } from "../../../../../utils/RoutesPaths";
import { COMPANY_VERIFICATION_STATUS } from "../../../../../utils/Constants";

const OffPlatformRequest = () => {
  const navigate = useNavigate();

  const lang = useSelector((state) => state.locale.lang);
  const { shared } = messages[lang];

  const requestDetails = useSelector(
    (state) =>
      state.businessVerification.offPlatformVerificationRequestDetails
  );

  const [addedDocsValues, setAddedDocsValues] = useState({});
  const [addedDocsErrors, setAddedDocsErrors] = useState({});

  const isSubmitBtnDisabled = () => {
    let isManualDocEntered = addedDocsValues.documents?.find(
      (doc) => doc.name
    );

    return (
      !!Object.keys(addedDocsErrors).length ||
      (!addedDocsValues.defaultDocument && !isManualDocEntered)
    );
  };

  return (
    <div className="offplatform-request-details">
      <div className="white-bg border-radius-10 p-4 mb-3">
        {requestDetails?.RequestStatusId ===
          COMPANY_VERIFICATION_STATUS.docsNeedUpdates && (
          <RequiredDocsEdit />
        )}
        {requestDetails?.RequestStatusId !==
          COMPANY_VERIFICATION_STATUS.pendingDocumentsUpload && (
          <CompanyInfoSection />
        )}
        {requestDetails?.RequestStatusId ===
          COMPANY_VERIFICATION_STATUS.awaitingRequiredDocuments && (
          <UploadDocuments
            onValuesChange={(values) => setAddedDocsValues(values)}
            onErrorsChange={(values) => setAddedDocsErrors(values)}
          />
        )}
        {requestDetails?.RequestStatusId ===
          COMPANY_VERIFICATION_STATUS.pendingDocumentsUpload && (
          <WaitingDocumentsUpload />
        )}

        {[
          COMPANY_VERIFICATION_STATUS.documentsUploaded,
          COMPANY_VERIFICATION_STATUS.docsNeedUpdates,
          COMPANY_VERIFICATION_STATUS.pendingPayment,
          COMPANY_VERIFICATION_STATUS.pendingFinalApproval,
          COMPANY_VERIFICATION_STATUS.rejected,
          COMPANY_VERIFICATION_STATUS.approved
        ].includes(requestDetails?.RequestStatusId) && (
          <DocumentsSection />
        )}
      </div>
      {requestDetails?.RequestStatusId ===
        COMPANY_VERIFICATION_STATUS.awaitingRequiredDocuments && (
        <div className="white-bg border-radius-10 p-4">
          <div className="d-flex align-items-center justify-content-between">
            <Button
              label={shared.cancel}
              outlined
              onClick={() =>
                navigate(ROUTE_PATHS.verificationRequests)
              }
              customSpacing={"px-2 px-md-5"}
            />
            <Button
              label={shared.send}
              type={"submit"}
              form={"offplatform-add-documents-form"}
              customSpacing={"px-2 px-md-5"}
              disabled={isSubmitBtnDisabled()}
            />
          </div>
        </div>
      )}
      {[
        COMPANY_VERIFICATION_STATUS.documentsUploaded,
        COMPANY_VERIFICATION_STATUS.docsNeedUpdates,
        COMPANY_VERIFICATION_STATUS.pendingPayment,
        COMPANY_VERIFICATION_STATUS.pendingFinalApproval,
        COMPANY_VERIFICATION_STATUS.rejected,
        COMPANY_VERIFICATION_STATUS.approved
      ].includes(requestDetails?.RequestStatusId) && (
        <div className="white-bg border-radius-10 p-4">
          <RepresentativeSection />
        </div>
      )}
      {[
        COMPANY_VERIFICATION_STATUS.pendingFinalApproval,
        COMPANY_VERIFICATION_STATUS.rejected,
        COMPANY_VERIFICATION_STATUS.approved
      ].includes(requestDetails?.RequestStatusId) &&
        requestDetails?.PaymentIntentId && (
          <div className="white-bg border-radius-10 p-4 mt-3">
            <TransactionDetails />
          </div>
        )}
    </div>
  );
};

export default OffPlatformRequest;
